/**
 * NOTE: this is a generated file that is produced at build time during
 * `treeForAddon`, if `publicOnly` is disabled.
 *
 * @private
 * @hide
 */
export default [];